import { ReduxStore } from 'store/types';

function getStatusDateChangedIsLoading(state: ReduxStore): boolean {
  return state.intervention.getStatusDateChanged.config.isLoading;
}

export default getStatusDateChangedIsLoading;
